import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidePanelState {
  open: boolean;
}

const initialState: SidePanelState = {
  // Initialize state from local storage if available
  open: true, // Default to true if no local storage value is found
};

const counterSlice = createSlice({
  name: "sidePanel",
  initialState,
  reducers: {
    setSidePanelDispatch: (state, action: PayloadAction<boolean>) => {
      localStorage.setItem("sidePanelState", String(action.payload));
      state.open = action.payload;
    },
  },
});

export const { setSidePanelDispatch } = counterSlice.actions;

export default counterSlice.reducer;
